import { lazy } from 'react';

const CertificatesInVerificationPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/certificates/verification',
			component: lazy(() => import('./CertificatesInVerificationContainer'))
		}
	]
};

export default CertificatesInVerificationPageConfig;